import type { SepaScheme } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';

export const hasSepaScheme =
    (...schemes: SepaScheme[]): TransactionPredicate =>
    ({ sepaScheme }) =>
        !!sepaScheme && schemes.includes(sepaScheme);
